<template>
  <div class="app-container signin-list">
    <basic-container class="signin-list-container">
      <el-button class="filter-item"
                     @click="handleExport()"
                     size="small"
                     type="primary"
                     :loading="exportLoading"
                     icon="el-icon-download">{{exportName}}
      </el-button>
      <div class="trend-summary">
        <div class="trend-summary-description">统计走势图</div>
        <div class="search-field">
          <el-date-picker
            class="search-field-daterange"
            v-model="searchedDateRange"
            type="daterange"
            value-format="yyyy-MM-dd"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            @change="selectDate"
            :clearable=false
            size="small">
          </el-date-picker>
        </div>
        <div ref="summaryChart" class="search-summary"></div>
      </div>
    </basic-container>
  </div>
</template>

<script>
  import {exportAnalysisSummaryData, getSigninStatisticsSummaryTrend} from '@/api/analysis/signinAnalysis'
  import { exporting } from '@/util/exportUtil'
  import * as echarts from 'echarts';
  import { formatDate } from '@/util/date';

  export default {
    name: "table_member",
    data() {
      return {
        ShowCustomerFiledDialog:false,
        exportLoading: false,
        exportName: "导出",
        customerSearchTime: [],
        list: [],
        listLoading: false,
        customerDateRangeFileds: [],
        expireTimeOption: {
          disabledDate(date) {
            return date.getTime() > Date.now();
          }
        },
        searchedDateRange: [],
        dateTypes: [],
        dateType: ''
      };
    },
    created() {
      this.init()
    },
    mounted() {
      this.drawChart()
    },
    methods: {
      init() {
        const end = new Date()
        const start = new Date()
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
        this.searchedDateRange.push(formatDate('YYYY-mm-dd', start))
        this.searchedDateRange.push(formatDate('YYYY-mm-dd', end))
      },
      selectDate(e) {
        this.drawChart()
      },
      handleExport() {
        let params = {}
        params.fromDate = this.searchedDateRange[0]
        params.toDate = this.searchedDateRange[1]
        exportAnalysisSummaryData(params).then(response => {
          if (response.status === 200 && response.data && response.data.data) {
            this.exportLoading = true
            this.exportName = "导出中..."
            exporting(response.data.data, this.exportCallback)
          } else {
            this.$message({
              message: '信息导出失败',
              type: 'warning',
              showClose: true,
            });
          }
        });
      },
      exportCallback(result) {
        this.exportLoading = false
        this.exportName = "导出"
        if (result) {
          this.$message({
            showClose: true,
            message: '导出完成',
            type: 'success'
            })
        }
      },
      drawChart () {
        let param = {}
        param.fromDate = this.searchedDateRange[0]
        param.toDate = this.searchedDateRange[1]

        getSigninStatisticsSummaryTrend(param).then(response => {
          var datas = []
          var dates = []
          response.data.data.forEach(item => {
            dates.push(item.date)
            datas.push(item.count)
          })
          var myChart = echarts.init(this.$refs.summaryChart);
          let options = {
            color: ['#57C6CD', '#C490BF', '#C1232B','#B5C334','#FCCE10','#E87C25','#27727B'],
            tooltip: {
              show: true,
              trigger: 'axis'
            },
            textStyle: {
              color: '#606266'
            },
            legend:{
              y: 'bottom',
              x: 'center'
            },
            xAxis: {
              data: dates,
            },
            grid: {
              x: 65,
              y: 30,
              x2: 35,
              y2: 65,
              borderWidth: 0
            },
            yAxis: {},
            series: [
              {
                name: "签到人数",
                type: "line",
                symbol: 'circle',
                data: datas,
              }
            ],
          }

          myChart.setOption(options);
        }).catch(() => {
          this.searchedDateRange.splice(0,this.searchedDateRange.length)
          this.init()
          this.selectDate()
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
.trend-summary {
  width: 100%;
  border: 1px solid #ededed;
  box-shadow: 0 1px 3px rgba(205, 205, 205, .5);
  &-description {
    color: #999;
    background: #f5f5f5;
    padding: 10px 15px 8px;
    font-size: 14px
  }
}

.search-field{
  display: flex;
  padding-top: 20px;
  padding-left: 15px;
  flex-direction: row;
  &-daterange {
    width: 400px!important;
    height: 36px;
  }
  &-datetype {
    padding-left: 10px;
    width: 150px!important;
  }
}

.search-summary {
  width: 100%;
  height: 400px;
}
</style>
